import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ListsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Lists",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.96 14.25a4.55 4.55 0 0 0 1.32-3.05 3.103 3.103 0 0 0-3.11-3.09 3.12 3.12 0 0 0-3.03 2.4v.02c1.58.91 2.63 2.59 2.64 4.52v8.8h3.5c.95 0 1.72-.77 1.72-1.72v-4.44a3.44 3.44 0 0 0-3.03-3.42h-.02ZM3.75 23.86h3.51v-8.8c.02-1.93 1.07-3.6 2.62-4.5h.03c-.33-1.41-1.56-2.44-3.04-2.44a3.11 3.11 0 0 0-3.11 3.09c.04 1.19.54 2.26 1.31 3.05-1.73.2-3.07 1.66-3.07 3.43v4.45c0 .95.77 1.72 1.72 1.72zm5.26-8.74v10.49c0 .95.77 1.72 1.72 1.72h10.53c.95 0 1.72-.77 1.72-1.72V15.12c0-1.93-1.57-3.5-3.5-3.5h-1.52c.27-.25.5-.54.7-.84v-.02c.17-.25.33-.53.45-.83v-.04c.24-.51.37-1.1.38-1.72 0-1.94-1.57-3.51-3.5-3.51s-3.5 1.57-3.5 3.5c.01.63.15 1.22.38 1.75v-.03c.13.33.28.62.46.88v-.02c.2.33.44.61.7.86s-1.54 0-1.54 0c-1.93 0-3.5 1.57-3.5 3.5Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M18.14 14.43c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.72c-.94 0-1.71.77-1.71 1.71s.77 1.71 1.71 1.71 1.71-.77 1.71-1.71-.77-1.71-1.71-1.71M19.86 30.43H7.29c-1.89 0-3.43-1.54-3.43-3.43V7.57a1.14 1.14 0 1 1 2.28 0V27c0 .63.51 1.14 1.14 1.14h12.57a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.43 25.86H11.86c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h12.57c1.89 0 3.43 1.54 3.43 3.43v17.14c0 1.89-1.54 3.43-3.43 3.43M11.86 4.14c-.63 0-1.14.51-1.14 1.14v17.14c0 .63.51 1.14 1.14 1.14h12.57c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H11.86Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.53 21.29a1.143 1.143 0 0 1-1.02-1.67c.91-1.74 2.68-2.82 4.62-2.82s3.72 1.08 4.62 2.82a1.143 1.143 0 0 1-2.03 1.05c-.51-.98-1.5-1.59-2.6-1.59s-2.08.61-2.59 1.59c-.2.39-.6.62-1.01.62Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.75 21.29c-.41 0-.81-.22-1.01-.62-.51-.98-1.5-1.59-2.6-1.59s-2.08.61-2.59 1.59a1.143 1.143 0 0 1-2.03-1.05c.91-1.74 2.68-2.82 4.62-2.82s3.72 1.08 4.62 2.82a1.143 1.143 0 0 1-1.02 1.67Z"
      })]
    })
  }));
};
ListsIcon.displayName = 'ListsIcon';